import { render, staticRenderFns } from "./BK_base-dropdown-picker.vue?vue&type=template&id=5ec1da5a&scoped=true&"
import script from "./BK_base-dropdown-picker.vue?vue&type=script&lang=js&"
export * from "./BK_base-dropdown-picker.vue?vue&type=script&lang=js&"
import style0 from "./BK_base-dropdown-picker.vue?vue&type=style&index=0&id=5ec1da5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1da5a",
  null
  
)

export default component.exports